import { connect } from 'react-redux'
import { change } from 'redux-form'
import { compose } from 'redux'
import { withStyles } from '@material-ui/core'
import { createStructuredSelector } from 'reselect'

import { BookingTableCellBase } from './BookingTableCell'

import { bookingActions } from 'reduxModules/actions/BookingActions'
import { cityActions } from 'reduxModules/actions/CityActions'
import { placesSelector, bookedPlacesSelector } from 'reduxModules/selectors/RouteSelectors'

import { styles } from './styles'

const mapStateToProps = createStructuredSelector({
  places: placesSelector,
  bookedPlaces: bookedPlacesSelector,
})

const mapDispatchToProps = {
  setSystemCity: cityActions.setSystemCity,
  changeFormValue: change,
  setPassengerPlace: bookingActions.setPassengerPlace,
}

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  withStyles(styles)
)

export const BookingTableCell = enhance(BookingTableCellBase)



// WEBPACK FOOTER //
// ./src/components/Bookings/components/BookingTableCell/index.js